import { ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnapshot } from "valtio";
import { authStore } from "@/store/auth";
import { useUser } from "@/features/auth/repositories/auth-repository"
import { TUser } from "@/types";
import { AuthContext } from "./context";



export default function AuthProvider({ children }: { children: ReactNode }) {
    const navigate = useNavigate();
    const location = useLocation();
    const auth = useSnapshot(authStore);

    const { user, isFetching } = useUser();

    const logout = () => {
        navigate("/auth/login", {replace: true});
    }

    useEffect(() => {
        if(auth.getToken() == null && auth.getUser() == null) {
            logout()
        }
    }, [user, location.pathname])

    useEffect(() => {
        if(user) {
            auth.setUser(user.results);
            auth.setUser(user.results);
        }
    }, [isFetching])

    return (
        <AuthContext.Provider value={{user: auth.getUser() as TUser, logout}}>
            {children}
        </AuthContext.Provider>
    )

}